export default {
  img: {
    width: '200px',
    height: '200px',
    margin: '10px 0 30px'
  }
}
